import { TicketSalePageEvent } from 'app/pages/TicketSalePage/slice/types';
import { VoucherInterface } from 'types/CartItem';
import { isTicket, isTopup, SelectedItems } from 'types/SelectedItem';
import {
  applyDiscountToPriceWithoutRoundUp,
  getFeePrice,
  getTaxPrice,
  getTotalOfItem,
} from 'utils/tickets';

export const getCartTotal = (
  selectedItems: SelectedItems,
  selectedEvent: TicketSalePageEvent,
  voucher: VoucherInterface,
  // should be removed
  hasTaxes: any = { hasPriceTax: true, hasFeeTax: true },
) => {
  const {
    voucherApplicableTickets,
    status: voucherStatus,
    voucherError,
    voucherData: { discount, discount_percent },
  } = voucher;
  let tmpCartTotal = 0;
  let tmpTaxTotal = 0;
  let tmpFeeTotal = 0;
  const { hasPriceTax, hasFeeTax } = hasTaxes;
  if (voucherStatus !== 'valid') {
    for (let i = 0; i < selectedItems.length; i++) {
      if (!isTopup(selectedItems[i])) {
        tmpCartTotal += getTotalOfItem(
          selectedItems[i].price,
          selectedItems[i].quantity,
        );
        if (hasPriceTax) {
          tmpTaxTotal += getTotalOfItem(
            selectedItems[i].tax,
            selectedItems[i].quantity,
          );
        }
        if (selectedItems[i].absorbFees === false) {
          if (hasFeeTax) {
            tmpTaxTotal += getTotalOfItem(
              selectedItems[i].feeTax,
              selectedItems[i].quantity,
            );
          }
          tmpFeeTotal += getTotalOfItem(
            selectedItems[i].fee,
            selectedItems[i].quantity,
          );
        }
      }
    }
  } else {
    for (let i = 0; i < selectedItems.length; i++) {
      const selectedItem = selectedItems[i];
      const ticketHasVoucherApplied =
        voucherApplicableTickets.findIndex(
          ticket => isTicket(selectedItem) && ticket === selectedItem.ticketId,
        ) >= 0;
      if (ticketHasVoucherApplied && !voucherError) {
        const {
          tax_rate: { rate: taxRate },
          fees,
          fee_tax_rate: { rate: feeTaxRate },
        } = selectedEvent;

        const ticketPriceBeforeDiscount = selectedItem.price;

        if (discount_percent === true) {
          const newTicketPrice = applyDiscountToPriceWithoutRoundUp(
            ticketPriceBeforeDiscount,
            discount,
            discount_percent,
          );
          const newTicketTax = getTaxPrice(newTicketPrice, taxRate);
          const newTicketFee = getFeePrice(newTicketPrice, fees);
          const newTicketFeeTax = getTaxPrice(newTicketFee, feeTaxRate);

          tmpCartTotal += getTotalOfItem(newTicketPrice, selectedItem.quantity);
          if (hasPriceTax) {
            tmpTaxTotal += getTotalOfItem(newTicketTax, selectedItem.quantity);
          }
          if (selectedItem.absorbFees === false) {
            if (hasFeeTax) {
              tmpTaxTotal += getTotalOfItem(
                newTicketFeeTax,
                selectedItem.quantity,
              );
            }
            tmpFeeTotal += getTotalOfItem(newTicketFee, selectedItem.quantity);
          }
        } else {
          const totalPriceAfterDiscount = applyDiscountToPriceWithoutRoundUp(
            ticketPriceBeforeDiscount,
            discount,
            false,
          );
          if (totalPriceAfterDiscount > 0) {
            const newTicketTax = getTaxPrice(totalPriceAfterDiscount, taxRate);
            const newTicketFee = getFeePrice(totalPriceAfterDiscount, fees);
            const newTicketFeeTax = getTaxPrice(newTicketFee, feeTaxRate);

            tmpCartTotal += getTotalOfItem(
              totalPriceAfterDiscount,
              selectedItem.quantity,
            );
            if (hasPriceTax) {
              tmpTaxTotal += getTotalOfItem(
                newTicketTax,
                selectedItem.quantity,
              );
            }
            if (selectedItem.absorbFees === false) {
              if (hasFeeTax) {
                tmpTaxTotal += getTotalOfItem(
                  newTicketFeeTax,
                  selectedItem.quantity,
                );
              }
              tmpFeeTotal += getTotalOfItem(
                newTicketFee,
                selectedItem.quantity,
              );
            }
          }
        }
      } else if (!isTopup(selectedItems[i])) {
        // this condition covers the paid addons & the tickets with no code applied
        tmpCartTotal += getTotalOfItem(
          selectedItem.price,
          selectedItem.quantity,
        );
        if (hasPriceTax) {
          tmpTaxTotal += getTotalOfItem(
            selectedItem.tax,
            selectedItem.quantity,
          );
        }
        if (selectedItem.absorbFees === false) {
          if (hasFeeTax) {
            tmpTaxTotal += getTotalOfItem(
              selectedItem.feeTax,
              selectedItem.quantity,
            );
          }
          tmpFeeTotal += getTotalOfItem(
            selectedItem.fee,
            selectedItem.quantity,
          );
        }
      }
    }
  }
  return {
    cartTotal: tmpCartTotal,
    taxTotal: tmpTaxTotal,
    feeTotal: tmpFeeTotal,
  };
};
